import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import Typography from "material-ui/Typography";
import DialogModal from "../../common/DialogModal";
import Button from "material-ui/Button";

const styles = () => ({
  paper: {
    maxHeight: "unset",
    borderRadius: "12px",
  },

  contentContainer: {
    borderRadius: "12px",
    padding: "52px 48px",
    margin: 0,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    width: "500px",
    boxSizing: "border-box",
    background: "#FFFFFF",
    textAlign: "left",
  },

  buttonContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginTop: "32px",
  },

  okButton: {
    color: "#FFFFFF",
    backgroundColor: "#1A65FF",
    fontSize: "16px",
    fontWeight: "bold",
    minWidth: "unset",
    minHeight: "unset",
    height: "47px",
    padding: "13px 50px",
    marginBottom: "30px",
    "&:hover": {
      backgroundColor: "#1A65FF",
      opacity: 0.6,
    },
  },

  planButton: {
    color: "#5A5B62",
    fontSize: "14px",
    fontWeight: "bold",
    background: "none",
    minWidth: "unset",
    minHeight: "unset",
    padding: "2px",
    "&:hover": {
      background: "none",
      textDecoration: "underline",
    },
  },
});

class DemoDialog extends React.Component {
  getCurrentPlanName = (suffix = null) => {
    const { user } = this.props;
    if (user && user.active_plan) {
      let name = user.active_plan.name;
      if (suffix) {
        name = name.endsWith(suffix) ? name : name + suffix;
      }
      return name;
    }

    return "";
  };

  render() {
    const { classes, toggleDialog, isOpen, togglePlanDialog } = this.props;

    return (
      <DialogModal
        open={isOpen}
        onClose={toggleDialog}
        maxWidth={false}
        classes={{
          paper: classes.paper,
          contentContainer: classes.contentContainer,
        }}
      >
        <Typography variant="title" style={{ marginBottom: "24px" }}>
          ダッシュボードのデモを表示します
        </Typography>

        <Typography variant="body2" style={{ fontSize: "14px" }}>
          ダッシュボード機能をご利用いただくにはプランの変更が必要です。お客様の現在のプランは
          {this.getCurrentPlanName("プラン")}です。
        </Typography>

        <div className={classes.buttonContainer}>
          <Button onClick={toggleDialog} className={classes.okButton}>
            OK
          </Button>
          <Button onClick={togglePlanDialog} className={classes.planButton}>
            プランを確認
          </Button>
        </div>
      </DialogModal>
    );
  }
}

DemoDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  isOpen: PropTypes.bool,
  toggleDialog: PropTypes.func,
  togglePlanDialog: PropTypes.func,
  user: PropTypes.object,
};

export default withStyles(styles)(DemoDialog);



// WEBPACK FOOTER //
// ./src/components/OrderDashboard/dialogs/DemoDialog.jsx